import React from 'react'

const AppointmentCalendar = () => {
  return (
    <div>AppointmentCalendar</div>
  )
}

export default AppointmentCalendar